import React, { useRef, useEffect} from 'react';
import './Authentication.css'

function Authentication({setIsVisible}) {


    // ******************* Observe if the component is loaded in the viewport **************

    const targetRef = useRef(null);
  
    useEffect(() => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          // entry.isIntersecting is true when the target element is visible
          if(entry.isIntersecting){
             setIsVisible("authentication");
          }
        },
        {
          root: null, // use the viewport as the root
          rootMargin: '0px', // no margin
          threshold: 0.5, // 0.5 means at least 50% of the target element must be visible
        }
      );
  
      if (targetRef.current) {
        observer.observe(targetRef.current);
      }
  
      // Cleanup the observer when the component is unmounted
      return () => {
        if (targetRef.current) {
          observer.unobserve(targetRef.current);
        }
      };
    }, []);

    return (
        <div ref={targetRef} id='authentication'>
            <div className='docs_side_text'>
                <h1>🔑 Authentication</h1>
                <p>The SheildScan API uses API keys to identify and authorize calls. You can register for a new API key in two ways:</p>
                <p>1. Recommended Directly on our dashboard<br/>2. SheildScan on RapidAPI marketplace</p>
                <p>The account on RapidAPI and on our Dashboard are dissociated. Each of these registration methods has its own base URL and API-KEY. You must therefore adapt your scripts according to your subscription by adapting the URL and your API KEY.</p>
                <p>The SheildScan API expects the API key to be included in all API requests to the server in a header that looks like this:</p>
                <p><li>For SheildScan Dashboard endpoint: <code>X-Api-Key: API_KEY</code></li></p>
                <p><li>For RapidAPI endpoint: <code>X-Rapidapi-Key: API_KEY</code></li></p>
                <br/>
                <div className='green_box'>
                    <h1>👉 Replace <code>API_KEY</code> with your API key</h1>
                </div>
                <p>Check out Using the API via Dashboard and Using the API via RapidAPI for additional information.</p>
                <div className='orange_box'>
                    <h2>🚧 Keep your API keys secret</h2>
                    <h1>Do not share your API keys in publicly accessible areas or put them in version control or client-side code. It's a good practice to set secrets like the API key as environment variable and then read it in the code.</h1>
                </div>


                {/* code to be completed after */}

                
            </div>
            <div className='authentication_side_code'>
            </div>
        </div>
    )
}

export default Authentication
